import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Button,
  CssBaseline,
  TextField,
  Paper,
  CircularProgress,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import FlexBox from "../../components/FlexBox";
import LightTextField from "../../components/LightTextField";
import { load, save } from "../../constants/storage";
import { H1, Small } from "../../components/Typography";
import { useNavigate, useLocation } from "react-router-dom";
import Carousel from "react-material-ui-carousel";
import { spalshItems } from "../../constants/constant";
import { RegisterRequest } from "../../models";
import { useAppDispatch } from "../../store/hooks";
import { userRegister } from "../../redux/actions/LoginAction";
import { PincodeRequest } from "../../models";
import { userPincode } from "../../redux/actions/LoginAction";
import toast from "react-hot-toast";
import {
  maxPincodeLength,
  partnerCode as defaultPartnerCode,
} from "../../common/common";

type FormValues = {
  firstname: string;
  lastname: string;
  dob: string;
  pincode: string;
};

type FormErrors = {
  firstname?: string;
  lastname?: string;
  dob?: string;
  pincode?: string;
  accountHolderName?: string;
  accountType?: string;
};
export default function Registration() {
  let navigate = useNavigate();
  let routeData = useLocation();
  const partnerCode = routeData.state?.partnerCode || defaultPartnerCode;
  const dispatch = useAppDispatch();
  const [city, setCity] = useState<string>("");
  const [state, setState] = useState<string>("");
  const [genderValue, setGenderValue] = useState("female");
  const [valid, setvalid] = useState<boolean>(false);
  const [formErrors, setFormErrors] = useState<FormErrors>({});
  const minDate = new Date();
  const [isLoaded, setIsLoaded] = useState(false);
  minDate.setFullYear(minDate.getFullYear() - 18); // Set the minimum date to 18 years ago
  useEffect(() => {
    const preloadImages = () => {
      const imagePromises = spalshItems.map((item) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = item.image;
          img.onload = resolve;
          img.onerror = reject;
        });
      });

      Promise.all(imagePromises)
        .then(() => {
          setIsLoaded(true);
        })
        .catch((error) => {
          setIsLoaded(true); // Set isLoaded to true even if there was an error to prevent blocking the UI
        });
    };

    preloadImages();
  }, []);
  const [formValues, setFormValues] = useState<FormValues>({
    firstname: "",
    lastname: "",
    dob: "",
    pincode: "",
  });
  const handleChangeGenderValue = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setGenderValue((event.target as HTMLInputElement).value);
  };

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;

    if (name === "pincode") {
      // Remove non-numeric characters from the input value
      const numericValue = value.replace(/\D/g, "");
      setFormValues({ ...formValues, [name]: numericValue });
    } else if (name === "firstname" || name === "lastname") {
      const alphabeticValue = value.replace(/[^A-Za-z]/g, "");
      setFormValues({ ...formValues, [name]: alphabeticValue });
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
    setFormErrors({ ...formErrors, [name]: "" });
  }

  const handleSubmit = async () => {
    const newErrors: FormErrors = {};
    const inputDateObj = new Date(formValues.dob);
    let inputdate = inputDateObj.setFullYear(inputDateObj.getFullYear());
    const today = new Date();
    let todaydate = today.setFullYear(today.getFullYear() - 18);
    if (formValues.firstname === "") {
      newErrors.firstname = "First name is required";
    }
    if (formValues.firstname?.length < 3) {
      newErrors.firstname = "First name should be more then 3 characters";
    }
    if (formValues.lastname === "") {
      newErrors.lastname = "Last name is required";
    }
    if (formValues.lastname?.length < 3) {
      newErrors.lastname = "Last name should be more then 3 characters";
    }
    if (formValues.pincode === "") {
      newErrors.pincode = "Pincode is required";
    }
    if (!formValues.dob) {
      newErrors.dob = "Please select a date";
    }
    if (inputdate > todaydate) {
      newErrors.dob = "Age must be greater then 18";
    }
    if (Object.keys(newErrors).length > 0) {
      setFormErrors(newErrors);
    } else {
      await userRegistration();
    }
  };

  const userRegistration = async () => {
    const firstName = formValues.firstname.replace(/\s+/g, " ").trim();
    const lasttName = formValues.lastname.replace(/\s+/g, " ").trim();
    let token = load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const data: RegisterRequest = {
      mobile: userDetails?.mobile,
      id: userDetails?.id,
      partner: userDetails?.refcode,
      firstname: firstName,
      lastname: lasttName,
      pincode: formValues.pincode,
      state: state,
      city: city,
      dob: formValues.dob,
      gender: genderValue.toUpperCase(),
      nationality: "Indian",
      email: "",
      email_article_enable: true,
      whatsapp_article_enable: true,
      sms_article_enable: true,
      address: "",
      latitude: 12.972,
      longitude: 77.595,
    };
    dispatch(userRegister(data, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.statusCode === 200) {
          await save("userData", JSON.stringify(response?.data[0]));
          navigate("/dashboard");
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const getUserPincode = async () => {
    let token = load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const data: PincodeRequest = {
      id: userDetails?.id,
      mobile: userDetails?.mobile,
      partner: userDetails?.refcode,
      pincode: formValues.pincode,
    };
    dispatch(userPincode(data, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.statusCode === 200) {
          setvalid(true);
          setCity(response.bankdata?.data?.city || "");
          setState(response.bankdata?.data?.state || "");
        } else {
          toast.error(response.message);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };
  const handleTextBlur = () => {
    getUserPincode();
  };

  return (
    <Grid
      container
      component="main"
      sx={{
        height: "100vh",
        alignItems: "center",
        display: "flex",
      }}
    >
      <CssBaseline />
      {/* Left Side  */}
      <Grid item xs={false} sm={4} md={6} sx={sxStyleGrid}>
        {partnerCode === "0" ? (
          <Box sx={sxStyleBoxCaresoul}>
            {isLoaded ? (
              <Carousel animation="slide">
                {spalshItems?.map((item) => (
                  <Box key={item.id}>
                    <Grid sx={sxStyleGridCaresoul}>
                      <Box
                        component="img"
                        src={item.image}
                        sx={sxStyleImageCaresoul}
                      />
                    </Grid>
                  </Box>
                ))}
              </Carousel>
            ) : (
              <Grid
                height="70vh"
                display="flex"
                flexDirection="column"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                }}
              >
                <CircularProgress />
              </Grid>
            )}
          </Box>
        ) : (
          <Box sx={sxStyleBoxCaresoulPartner}>
            {isLoaded ? (
              <Carousel animation="slide">
                {spalshItems?.map((item) => (
                  <Box key={item.id}>
                    <Grid sx={sxStyleGridCaresoul}>
                      <Box
                        component="img"
                        src={item.image}
                        sx={sxStyleImageCaresoul}
                      />
                    </Grid>
                  </Box>
                ))}
              </Carousel>
            ) : (
              <Grid
                height="70vh"
                display="flex"
                flexDirection="column"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                }}
              >
                <CircularProgress />
              </Grid>
            )}
            <Box
              sx={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                component="img"
                sx={{
                  height: {
                    xs: "10%",
                    sm: "10%",
                    md: "25%",
                  },
                  width: {
                    xs: "17%",
                    sm: "17%",
                    md: "35%",
                  },
                  mt: 5,
                }}
                src={process.env.REACT_APP_PARTNERSHIP}
                alt="saas-dasboard-footer"
              />
            </Box>
          </Box>
        )}
      </Grid>

      {/* Right Side */}
      <Grid item xs={12} sm={4} md={6} component={Paper} sx={sxStyleGrid1}>
        <Grid md={10} sx={sxStyleBox}>
          <Grid
            sx={{
              justifyContent: {
                md: "flex-start",
                sm: "flex-start",
                xs: "center",
              },
              alignItems: "center",
              display: "flex",
            }}
          >
            <Box
              component="img"
              src={process.env.REACT_APP_LOGO}
              sx={sxStyleImage}
            />
          </Grid>
          <H1 fontSize={24} fontWeight={600} sx={sxStyleH1} color="#013283">
            Let's set up your account
          </H1>
          <Small fontWeight={300} sx={sxStyleSmall} color="#595959">
            To start using our app, we need you to enter the following details:
          </Small>
          <Box sx={sxStyleBox1}>
            <form style={{ width: "100%" }}>
              <FlexBox
                justifyContent="space-between"
                flexWrap="wrap"
                flexDirection={"row"}
              >
                <LightTextField
                  name="firstname"
                  type="name"
                  label="First Name"
                  value={formValues.firstname}
                  onChange={handleChange}
                  inputProps={{
                    inputMode: "text",
                    pattern: "[A-Za-z]*",
                  }}
                  error={!!formErrors.firstname}
                  helperText={formErrors.firstname}
                  sx={{
                    width: { xs: "100%", sm: "100%", md: "49%" },
                  }}
                />

                <LightTextField
                  name="lastname"
                  type="name"
                  label="Last Name"
                  inputProps={{
                    inputMode: "text",
                    pattern: "[A-Za-z]*",
                  }}
                  value={formValues.lastname}
                  onChange={handleChange}
                  error={!!formErrors.lastname}
                  helperText={formErrors.lastname}
                  sx={{
                    width: { xs: "100%", sm: "100%", md: "49%" },
                    marginTop: { xs: 2, sm: 2, md: 0 },
                  }}
                />
              </FlexBox>
              <FlexBox
                justifyContent="space-between"
                flexWrap="wrap"
                flexDirection={"row"}
                marginTop={2}
              >
                <TextField
                  name="dob"
                  label="Date of birth"
                  type="date"
                  value={formValues.dob}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    max: minDate.toISOString().split("T")[0], // Set the maximum date
                  }}
                  sx={{
                    borderRadius: "10px",
                    placeholderStyle: 50,
                    width: { xs: "100%", sm: "100%", md: "49%" },
                    marginTop: { xs: 2, sm: 2, md: 0 },
                  }}
                  error={!!formErrors.dob}
                  helperText={formErrors.dob}
                />

                <LightTextField
                  name="pincode"
                  type="pincode"
                  label="Pin Code"
                  onBlur={handleTextBlur}
                  value={formValues.pincode}
                  onChange={handleChange}
                  error={!!formErrors.pincode}
                  helperText={formErrors.pincode}
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    maxLength: maxPincodeLength,
                  }}
                  sx={{
                    width: { xs: "100%", sm: "100%", md: "49%" },
                    marginTop: { xs: 2, sm: 2, md: 0 },
                  }}
                />
              </FlexBox>
              <Box fontSize={18} sx={sxStyleSmall1} color="#595959">
                Gender
              </Box>
              <RadioGroup
                row
                value={genderValue}
                onChange={handleChangeGenderValue}
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
              >
                <FormControlLabel
                  sx={sxStyleFormalControlLabel}
                  value="female"
                  control={<Radio sx={sxStyleRadio} />}
                  label="Female"
                />
                <FormControlLabel
                  sx={sxStyleFormalControlLabel}
                  value="male"
                  control={<Radio sx={sxStyleRadio} />}
                  label="Male"
                />
              </RadioGroup>
            </form>

            <Button
              onClick={() => handleSubmit()}
              type="submit"
              variant="contained"
              size="medium"
              disabled={!valid}
              sx={[sxStyleButton, { textTransform: "none" }]}
            >
              Submit
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
}

const sxStyleGrid = {
  backgroundRepeat: "no-repeat",
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  backgroundSize: "cover",
  backgroundPosition: "center",
  maxWidth: {
    xs: "0%",
    sm: "0%",
    md: "80%",
  },
  height: "100vh",
};
const sxStyleGridCaresoul = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
};
const sxStyleBoxCaresoul = {
  maxWidth: {
    xs: "0%",
    sm: "0%",
    md: "90%",
  },
  my: 8,
  mx: {
    xs: 0,
    sm: 0,
    md: 4,
  },
  background: "transaparent",
  paddingX: 4,
  paddingY: 0,
};

const sxStyleBoxCaresoulPartner = {
  maxWidth: {
    xs: "0%",
    sm: "0%",
    md: "80%",
  },
  my: 4,
  mx: {
    xs: 0,
    sm: 0,
    md: 4,
  },
  background: "transaparent",
  paddingX: 4,
  paddingY: 5,
};
const sxStyleImageCaresoul = {
  height: {
    xs: "30%",
    sm: "30%",
    md: "5%",
  },
  width: {
    xs: "100%",
    sm: "100%",
    md: "70%",
  },
  marginBottom: 4,
};
const sxStyleGrid1 = {
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  height: "100vh",
};
const sxStyleBox = {
  maxWidth: {
    xs: "100%",
    sm: "100%",
    md: "95%",
  },
  my: 0,
  mx: {
    xs: 1,
    sm: 1,
    md: -4,
  },
  background: "#fff",
  borderRadius: 5,
  paddingX: { xs: 1, md: 4, sm: 4 },
  paddingY: 5,
  boxShadow: {
    xs: 0,
    sm: 2,
    md: 3,
  },
};
const sxStyleBox1 = {
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  display: "flex",
  mt: 2,
};
const sxStyleImage = {
  width: {
    xs: "30%",
    sm: "60%",
    md: "20%",
  },
  mt: 2,
  mb: 2,
  alignSelf: "center",
};
const sxStyleH1 = {
  mt: 3,
  textAlign: "left",
  fontFamily: "'Poppins', sans-serif",
};
const sxStyleSmall = {
  textAlign: "left",
  width: "100%",
  fontFamily: "'Poppins', sans-serif",
};
const sxStyleSmall1 = {
  textAlign: "left",
  width: "100%",
  fontFamily: "'Poppins', sans-serif",
  fontWeight: "400",
  mt: 2,
};
const sxStyleFormalControlLabel = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: "400",
};
const sxStyleButton = {
  mt: 3,
  mb: { xs: "0%", sm: "12%", md: "12%" },
  py: 1,
  fontFamily: "'Poppins', sans-serif",
  width: {
    xs: "100%",
    sm: "100%",
    md: "60%",
  },
  alignSelf: "center",
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
};

const sxStyleRadio = {
  color: "#FFF5D1",
  "&.Mui-checked": {
    color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
  },
};
